import * as React from 'react';
export const checkCircleFilledSvg = React.forwardRef(
  function checkCircleFilledSvgInner(props, ref) {
    return /*#__PURE__*/ React.createElement(
      'svg',
      {
        ...props,
        ref: ref,
      },
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Zm4.28-9.72a.75.75 0 1 0-1.06-1.06L7 9.44 5.03 7.47a.75.75 0 0 0-1.06 1.06l2.5 2.5a.75.75 0 0 0 1.06 0l4.75-4.75Z',
      }),
    );
  },
);
checkCircleFilledSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var checkCircleFilled = {
  category: 'icon',
  colorable: true,
  name: 'checkCircleFilled',
  svg: checkCircleFilledSvg,
};
